export class VehicleWatchContactModel {
    public id: number;
    public customerNumberId: number;
    public phone1: string;
    public phone2: string;
    public isRedacted: boolean;
}
